import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, NgForm, FormControl } from '@angular/forms';
import { User } from '../../user';
import { AuthService } from '../../auth.service';
import { AuthState } from '../../auth-state';
import { PersonService } from 'src/app/shared/services/person.service';
import { Router } from '@angular/router';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { ErrorStateMatcher } from '@angular/material/core';
import { HttpService } from 'src/app/core/http/http.service';
import { GeneralService } from 'src/app/shared/services/general.service';
import { Subscription } from 'rxjs';
import { Document } from 'src/app/shared/models/document';
import { API } from 'src/app/configs';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent extends AbstractForm implements OnInit, OnDestroy {

  showStates = [AuthState.SIGN_UP];

  @ViewChild('inputName') inputNameEl: ElementRef;

  params:any = {};
  formType = 'realtor';

  perfil_id = '3';
  title = 'Cadastro';

  private hash = false;
  
  message:String = '';

  _show: boolean;
  _loading: boolean;
  _disabled: any = [];

  states = [];

  termsActive: boolean = false;

  matcher = new MyErrorStateMatcher();

  settingsLoad:Subscription;

  formGroupRealestate: FormGroup;

  formGroupBuilder: FormGroup;

  constructor(
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    private authService: AuthService,
    private personService: PersonService,
    private router: Router,
    protected httpService: HttpService,
    protected gs : GeneralService
    ) {
      super(formBuilder, logger, false);
      
  }

  ngOnInit(){

    if(this.params?.perfil_id)
      this.perfil_id = this.params.perfil_id;

    if(this.params?.type)
      this.formType = this.params?.type;

    this.title = this.perfil_id == '3'? 'Cadastro' : 'Cadastro de usuário';

    if(this.params?.hash)
      this.hash = this.params.hash;

    this.formDefault();

    this._show = true;

    this.settingsLoad = this.gs.settingsLoad$.subscribe(result =>{
      this.states = result?.states || []
    });

    if(this.params?.email){
      this._disabled['email'] = true;
      this.getControl('email')?.disable();
    }

    setTimeout(()=> this.inputNameEl.nativeElement.focus(), 300);

    this.formGroupRealestate = this.formBuilder.group({
      //city: ['', [Validators.required, Validators.minLength(3)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      position : ['', [Validators.required]],
      company_creci_code: ['', [Validators.required, Validators.minLength(4)]],
      company_creci_state_id: ['1', [Validators.required]],
      cellphone: ['', [Validators.required, Validators.minLength(10)]],
      company_document: ['', [Validators.required, Document.validate('cnpj')]],
      privacy: [false, [Validators.required, Validators.requiredTrue]],      
      source_action: ['cadastro'],
      source: ['site']
    });

    this.formGroupBuilder = this.formBuilder.group({
      //city: ['', [Validators.required, Validators.minLength(3)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: ['', [Validators.required, Validators.email]],
      position : ['', [Validators.required]],
      cellphone: ['', [Validators.required, Validators.minLength(10)]],
      company_document: ['', [Validators.required, Document.validate('cnpj')]],
      privacy: [false, [Validators.required, Validators.requiredTrue]],      
      source_action: ['cadastro'],
      source: ['site']
    });

  }

  ngOnDestroy(){
    this.settingsLoad?.unsubscribe();
  }

  buildFormGroup(): FormGroup {


    let passRequirement = {
      passwordMinLowerCase: 1,
      passwordMinNumber: 1,
      passwordMinSymbol: 0,
      passwordMinUpperCase: 0,
      passwordMinCharacters: 8
    };
    let pattern = [
      `(?=([^a-z]*[a-z])\{${passRequirement.passwordMinLowerCase},\})`,
      `(?=([^A-Z]*[A-Z])\{${passRequirement.passwordMinUpperCase},\})`,
      `(?=([^0-9]*[0-9])\{${passRequirement.passwordMinNumber},\})`,
      `(?=(\.\*[\$\@\$\!\%\*\?\&])\{${passRequirement.passwordMinSymbol},\})`,
      `[A-Za-z\\d\$\@\$\!\%\*\?\&\.]{${
        passRequirement.passwordMinCharacters
      },}`
    ]
      .map(item => item.toString())
      .join("");

    let pwdValidator = Validators.pattern(pattern);

    let creci = this.perfil_id == '3'? {
      creciCode: ['', [Validators.required, Validators.minLength(4)]],
      creciState: ['', [Validators.required]]
      //,document: [false, [Validators.required, Validators.requiredTrue]]
    } : {};
    return this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(5)]],
      email: [this.params?.email || '', [Validators.required, Validators.email]],
      cellphone: ['', [Validators.required, Validators.minLength(10)]],
      ...creci,
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],//, pwdValidator]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],//, pwdValidator]],
      privacy: [false, [Validators.required, Validators.requiredTrue]],
    }, { validator: this.checkPasswords });
  }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.controls.password.value;
    let confirmPass = group.controls.confirmPassword.value;
    
    return pass === confirmPass ? null : { notSame: true }
  }

  updateControls() {}
  updateObject(): any {

  }

  getUser(): User {
    return new User(
      this.getControlValue('email'),
      this.getControlValue('name'),
      this.getControlValue('password'),
      this.getControlValue('email'),
      '+'+this.getControlValue('cellphone').replace(/\(|\)|-|\s/gi,""),
      this.getControlValue('creciCode'),
      this.getControlValue('creciState'),
      null,
      null,
      'site'
    );
  }

  onSignUp() {
    if(this.formGroup.valid){
      this._loading = true;
      this.personService.signUp(this.getUser(), this.hash)
        .catch(err => {
          this.message = err?.message;
        })
        .finally(() => this._loading = false);
    }
  }

  onSignIn() {
    //this.authService.changeAuthState(AuthState.SIGN_IN, null);
    this.router.navigate(['openModal','AuthenticatorComponent']);
  }

  onConfirmSignUp() {
    this.authService.changeAuthState(AuthState.CONFIRM_SIGN_UP, new User(this.getControlValue('email')));
  }

  isSigneout(){
    return this.authService.getActualAuthState().state == AuthState.SIGNED_OUT;
  }

  openTerms(){
    this.router.navigate(['openModal','TermsComponent']);
  }
  openAdverstise(){
    this.router.navigate(['openModal','AdvertiseFormComponent']);
  }

  phoneMethod(event,field, formGroup = this.formGroup){
    switch(event.type){
      case 'focus':
        if(!this.getControlValue(field, formGroup))
          this.setControlValue(field,'55', formGroup);
      break;
      case 'blur':
        if(this.getControlValue(field, formGroup) == '55')
          this.setControlValue(field,null, formGroup);
      break;
    }
  }


  setType(type){
    this.formType = type;
  }

  realestateSignUp(){
    let data = this.getFormValues(this.formType == 'realestate'? this.formGroupRealestate : this.formGroupBuilder);

    this._loading = true;
    this.httpService.post<any>(this.formType == 'realestate'? API.general.leadRealestate : API.general.leadBuilder, data)
        .then(result => {
            this.message = 'Dados enviados, em breve nossa equipe entrará em contato';

            if(this.formType == 'realestate')
              this.formGroupRealestate.reset();
            else
              this.formGroupBuilder.reset();
        })
        .catch((err) =>  this.gs.error(err))
        .finally(() => this._loading = false);
  }

}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    return (invalidCtrl);
  }
}